var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWinnericon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_76_124)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_76_124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.0165 86.3193L50.1563 69.1569C49.6754 68.1071 49.8145 66.801 50.4995 65.9328L58.3597 55.9703C59.2531 54.838 60.7472 54.838 61.6406 55.9703L69.5008 65.9328C70.1858 66.801 70.3248 68.1071 69.844 69.1569L61.9838 86.3193C61.1204 88.2046 58.8799 88.2046 58.0165 86.3193Z",
    fill: "#FFF8DE"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.5859 84.932C29.5859 83.4881 30.7918 82.3176 32.2794 82.3176H87.7208C89.2084 82.3176 90.4143 83.4881 90.4143 84.932V95.3744C90.4143 96.8183 89.2084 97.9888 87.7208 97.9888H32.2794C30.7918 97.9888 29.5859 96.8183 29.5859 95.3744V84.932Z",
    fill: "#FF7A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2815 42.7639L55.3742 18.4275C57.2851 14.5818 62.7152 14.5818 64.6262 18.4275L76.7188 42.7639C78.1628 45.6698 81.851 46.555 84.4328 44.6152L94.2099 37.2694C97.8537 34.5317 102.97 37.5238 102.439 42.082L97.0737 88.1533C96.7668 90.7888 94.5573 92.775 91.9323 92.775H28.068C25.443 92.775 23.2336 90.7888 22.9266 88.1532L17.5611 42.082C17.0303 37.5238 22.1467 34.5317 25.7905 37.2694L35.5676 44.6152C38.1494 46.555 41.8376 45.6698 43.2815 42.7639Z",
    fill: "url(#paint0_radial_76_124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9344 53.1023C58.0071 50.4438 61.9933 50.4438 64.066 53.1023L72.0885 63.3925C73.57 65.2927 73.57 67.9718 72.0885 69.872L64.066 80.1621C61.9933 82.8207 58.0071 82.8207 55.9344 80.1621L47.9119 69.872C46.4304 67.9718 46.4304 65.2927 47.9119 63.3925L55.9344 53.1023Z",
    fill: "url(#paint1_radial_76_124)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_76_124",
    x: 13.5229,
    y: 11.5432,
    width: 92.9543,
    height: 90.4456,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.780392 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_76_124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_76_124",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_76_124",
    x: 45.8721,
    y: 52.1211,
    width: 28.2561,
    height: 40.6121,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.68 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_76_124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_76_124",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.914286 0 0 0 0 0.55 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_76_124"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_76_124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.6889 46.1744) rotate(56.9028) scale(55.6261 49.5048)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682292,
    stopColor: "#FFC839"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_76_124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.7056 60.5276) rotate(65.4804) scale(20.9122 22.2719)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7D16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3E12"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinnericon);
export default __webpack_public_path__ + "static/media/winnericon.75f9c3c976446fbfce52202bb650ab1a.svg";
export { ForwardRef as ReactComponent };